import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PortalPageHeader } from "@/components/portal/PortalLayout";
import { StatBadge } from "@/components/admin/AdminLayout";

export default function PartnerBookings() {
  const [bookings, setBookings] = useState([]);
  useEffect(() => { api.get("/partner/bookings").then((r) => setBookings(r.data)); }, []);
  return (
    <div className="p-10 max-w-[1400px]">
      <PortalPageHeader eyebrow="Reservations" title="Bookings" description="All bookings that came through your channel." />
      <div className="bg-white border border-slate-200 shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
              <th className="p-4">Ref</th>
              <th className="p-4">Date</th>
              <th className="p-4">Client</th>
              <th className="p-4">Route</th>
              <th className="p-4 text-right">Client pays</th>
              <th className="p-4 text-right">Your earning</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.length === 0 && <tr><td colSpan={7} className="p-10 text-center text-slate-500">No bookings yet.</td></tr>}
            {bookings.map((b) => (
              <tr key={b.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`partner-booking-${b.id}`}>
                <td className="p-4 font-mono text-[#f59e0b] text-xs">{b.reference}</td>
                <td className="p-4 text-xs text-slate-600">{new Date(b.service_datetime).toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" })}</td>
                <td className="p-4"><div className="text-[#0a0f1e]">{b.client_name}</div><div className="text-xs text-slate-500">{b.client_email}</div></td>
                <td className="p-4 text-xs text-slate-600 max-w-[240px]"><div className="truncate">{b.pickup_address}</div><div className="truncate text-slate-500">→ {b.destination_address}</div></td>
                <td className="p-4 text-right font-mono text-[#0a0f1e]">€{(b.client_pays || b.total_amount)?.toFixed(2)}</td>
                <td className="p-4 text-right font-mono text-[#f59e0b]">€{(b.partner_earning || b.partner_fee || 0)?.toFixed(2)}</td>
                <td className="p-4"><StatBadge status={b.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
